export default __webpack_public_path__ + "static/media/Vasa-Large.694fe199.png";